import { upcomingMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function Upcoming() {
  return (
    <section id="upcoming" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="即将上线 · 排片预告"
            title="接下来值得留意的影片"
            desc="以下影片已进入排期待映阶段。上线后会在“今日更新”与对应题材分类中同步出现在列表里。"
          />
          <span className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-secondary-100 text-secondary-900 text-sm shrink-0">
            <i className="ri-calendar-schedule-line"></i>
            共 {upcomingMovies.length} 部待映
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {upcomingMovies.map((m) => (
            <article key={m.id} className="group">
              <div className="relative rounded-lg overflow-hidden aspect-[2/3] bg-background-200 border border-background-200/70">
                <img
                  src={m.poster}
                  alt={`${m.title} 待映影片预告海报，${m.genre}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-[11px] font-medium">
                  {m.month}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading font-bold text-base md:text-lg text-background-50">{m.title}</h3>
                  <p className="mt-1 text-xs text-background-200/85">{m.genre}</p>
                </div>
              </div>
              <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-600">
                <i className="ri-bookmark-3-line text-accent-600 mr-1"></i>
                {m.reason}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}